import type { FaireProductEntity } from "../../entity_types/product";

export const p_hm6a8e4hey: FaireProductEntity = {
  token: "p_hm6a8e4hey",
  type: "product",
  name: "MELODY - 100ml Eau de Parfum",
  brandToken: "b_cw7sx8wpgu",
  brandName: "Miller Harris",
  imageUrl:
    "https://cdn.faire.com/fastly/0170735ea6fe851abf5a1bd05ba5cf32a31adb3525bd46fb56e82ab8308826f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21163ce77d225799c4dcb66074b671a16e628afd80c93438e74289448d3b2c01.jpeg",
    "https://cdn.faire.com/fastly/85cc32f206746f620aab09bdaea56cf8a5946883d8c940aca3954b4715549f7e.jpeg",
    "https://cdn.faire.com/fastly/edcd2f7d66ff66d3600e495793801de9b30c526ec039c500ac83e8774f7d0053.jpeg",
    "https://cdn.faire.com/fastly/c982470e65e4be71e78e1dcafa61cddf736a494767b7e754c021003009a65b69.jpeg",
    "https://cdn.faire.com/fastly/ff4e331c72b3ef223bec32ec3c957f22686d4a6c121515acb45f648dce962966.jpeg",
    "https://cdn.faire.com/fastly/55b927e668b36480f80483aeded137b679e752259c1e045722b17f27d0d970a7.jpeg",
    "https://cdn.faire.com/fastly/495cc37d113860b4bd278aa3054c40f83f4c7a5176b440c13818221faaa08564.jpeg",
  ],
  priceDollars: 122.5,
  description:
    "The latest floral musk from Miller Harris. At the heart of the fragrance is the delicate caress of natural rose, embraced by a soft, comforting white musk and deep warmth of cashmere and vanilla.\nA quiet intimacy and the delicate longing of first love form the soul of Melody Eau de Parfum, a new addition to the Stories Collection. Inspired by a passage of text from British-Ghanaian writer Caleb Azumah Nelson’s groundbreaking first novel ‘Open Water’. White musk gently envelops a luminous floral-green heart, evoking the ethereal beauty of modern romance.\nThese elements are embraced by a soft, comforting white musk accord, creating a fragrance that speaks of longing, quiet desire, and gentle connection. The opening is a bright and inviting blend of blackcurrant and bergamot, offering an immediate sweetness that gives way to the deep warmth of cashmere and vanilla and the crisp, grounding presence of cedarwood and vanilla in the dry-down.",
  tags: [],
  msrpDollars: 245,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:43.457Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
